import Accordion from './accordion';

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll<HTMLElement>('.js-accordion');

  accordions.forEach((acc) => {
    const accordion = new Accordion(acc);
    accordion.bindEvents();
  });
});
